import { gql } from '@apollo/client';

export default gql`
	query TermItems($termType: String!) {
		termItems(termType: $termType, take: 9999) {
			data {
				id
				name
				value
			}
		}
	}
`;
